(ns shared.core.components.google-maps.views
  (:require [shared.core.components.dropdown :refer [dropdown]]
            [shared.core.components.google-maps.data :as maps.d]
            [shared.core.components.input :refer [input]]
            [shared.core.config :as config]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [clojure.string :as s]))

(defn map-iframe [{:keys [latitude longitude zoom embed-type style height width label street-address city state-code
                          postal-code formatted-address]
                   :or {zoom 19
                        embed-type "place"
                        height "100%"
                        width "100%"}}]
  (let [address (or (when (not-empty formatted-address) formatted-address)
                    (some->> [label street-address city state-code postal-code]
                             (filter #(not (s/blank? %)))
                             (s/join " ")))]
    [:iframe {:src (str "https://www.google.com/maps/embed/v1/"
                        embed-type
                        "?zoom=" zoom
                        (when (and (= embed-type "view") latitude longitude)
                          (str "&center=" latitude "," longitude))
                        (when (and (= embed-type "place") (or (and latitude longitude) (not-empty address)))
                          (str "&q=" (if (not-empty address)
                                       (js/encodeURIComponent address)
                                       (str latitude "," longitude))))
                        "&key=" config/GOOGLE_MAPS_API_KEY)
              :loading :lazy
              :allow-full-screen true
              :style (merge {:border 0} style)
              :height height
              :width width}]))

(defn places-autocomplete [{:keys [options-form-path options-form-name]}]
  (let [base-options- (re/subscribe [:form/val- options-form-path options-form-name])
        search-query* (re/ratom nil)]
    (fn [{:keys [form-path form-name place-load-success-event place-fields location prepend-options extra-on-change
                 extra-on-custom-click force-form-save?]
          :as args}]
      (let [base-options @base-options-
            options-loading? (or (util/loading? prepend-options) (util/loading? base-options))]
        [dropdown (merge {:no-results-message "Start Typing to Search"
                          :search? true
                          :skip-search-filter? true
                          :on-search-change (fn [_ d]
                                              (let [search-query (some->> d (js->clj) (util/->kebab-case-keywords) :search-query)]
                                                (reset! search-query* search-query)
                                                (if (s/blank? search-query)
                                                  (re/dispatch [:form/change options-form-path options-form-name []])
                                                  (maps.d/load-autocomplete-results-debounced
                                                    (assoc args :input search-query
                                                                :location location
                                                                :callback (fn [predictions]
                                                                            (re/dispatch [:form/change
                                                                                          options-form-path
                                                                                          options-form-name
                                                                                          predictions])))))))
                          :options (if options-loading?
                                     :loading
                                     (let [opts (concat []
                                                        (some->> prepend-options
                                                                 (filter #(or (s/blank? @search-query*)
                                                                              (s/starts-with? (s/trim (s/lower-case (:text %)))
                                                                                              (s/trim (s/lower-case @search-query*)))))
                                                                 (mapv (fn [o] (assoc o :custom-option? true))))
                                                        base-options)]
                                       (if (some-> opts (first) :key)
                                         (util/distinct-by :key opts)
                                         opts)))
                          :loading? options-loading?
                          :key? false
                          :form-path form-path
                          :form-name form-name
                          :on-change (fn [e d]
                                       (let [o (util/->kebab-case-keywords (js->clj d))
                                             selected-option-custom? (some->> o
                                                                              :options
                                                                              (filter #(= (:value %) (:value o)))
                                                                              (first)
                                                                              :custom-option?)]
                                         (if selected-option-custom?
                                           (do
                                             (when extra-on-custom-click
                                               (extra-on-custom-click o e d))
                                             (when (and form-path form-name)
                                               (re/dispatch [:form/change form-path form-name (:value o)])))
                                           (re/dispatch [:google-maps/load-place-result {:place-id (:value o)
                                                                                         :fields place-fields
                                                                                         :success-event place-load-success-event}]))
                                         (when (and force-form-save? form-path form-name)
                                           (re/dispatch [:form/change form-path form-name (:value o)]))
                                         (when extra-on-change
                                           (extra-on-change e d))))}
                         (dissoc args :force-form-save?))]))))

(defn places-autocomplete-input
  [{:keys [options-form-path options-form-name]}]
  (fn [{:keys [location radius extra-on-change] :as args}]
    [input (merge {:extra-on-change (fn [v]
                                      (if (s/blank? v)
                                        (re/dispatch [:form/change options-form-path options-form-name []])
                                        (maps.d/load-autocomplete-results-debounced
                                          {:input v
                                           :location location
                                           :radius radius
                                           :callback (fn [predictions]
                                                       (re/dispatch [:form/change
                                                                     options-form-path
                                                                     options-form-name
                                                                     predictions]))}))
                                      (when extra-on-change
                                        (extra-on-change v)))}
                  args)]))
